const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSetting(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.014 53.809V50.8a.639.639 0 0 0-.639-.639h-1.729a.645.645 0 0 1-.62-.49 10.22 10.22 0 0 0-1.076-2.571.645.645 0 0 1 .091-.788l1.229-1.229a.64.64 0 0 0 0-.9l-2.126-2.126a.639.639 0 0 0-.9 0l-1.25 1.243a.646.646 0 0 1-.784.094 10.221 10.221 0 0 0-2.56-1.049.645.645 0 0 1-.494-.621v-1.779a.639.639 0 0 0-.639-.639h-3.006a.639.639 0 0 0-.639.639v1.808a.645.645 0 0 1-.487.619 10.246 10.246 0 0 0-2.52 1.058.646.646 0 0 1-.788-.091l-1.289-1.29a.64.64 0 0 0-.9 0l-2.125 2.126a.639.639 0 0 0 0 .9l1.3 1.3a.645.645 0 0 1 .093.784 10.214 10.214 0 0 0-1.035 2.506.646.646 0 0 1-.621.49h-1.846a.639.639 0 0 0-.639.639V53.8a.639.639 0 0 0 .639.639h1.846a.646.646 0 0 1 .621.491 10.217 10.217 0 0 0 1.035 2.51.645.645 0 0 1-.094.783l-1.3 1.3a.639.639 0 0 0 0 .9l2.125 2.126a.64.64 0 0 0 .9 0l1.282-1.282a.646.646 0 0 1 .789-.091 10.225 10.225 0 0 0 2.526 1.062.646.646 0 0 1 .487.619v1.8a.639.639 0 0 0 .639.639h3.006a.639.639 0 0 0 .639-.639V62.9a.645.645 0 0 1 .494-.621 10.225 10.225 0 0 0 2.567-1.053.646.646 0 0 1 .784.093l1.239 1.239a.639.639 0 0 0 .9 0l2.126-2.126a.639.639 0 0 0 0-.9l-1.225-1.224a.646.646 0 0 1-.091-.788 10.223 10.223 0 0 0 1.075-2.581.646.646 0 0 1 .62-.491h1.726a.639.639 0 0 0 .644-.639zm-12.941 3.4a4.9 4.9 0 1 1 4.9-4.9 4.9 4.9 0 0 1-4.9 4.902z",
    transform: "translate(-694.014 -34.306)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      fill: "none"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetting);
export default __webpack_public_path__ + "static/media/icon-setting.07c9237b7a775966e0e164afc25037ef.svg";
export { ForwardRef as ReactComponent };